import { InfoDialog } from '@strata/react-dialog';
import { DetailLabelValuePair } from '@strata/react-label-value-pairs';
import { Spinner } from '@strata/react-loading-animation';
import PropTypes from 'prop-types';

import { useGetBenefitAttributesByGroupQuery } from 'store/api/clientApi';

export const AdditionalBenefitInfoDialog = ({
    payerId = undefined,
    benefitGroup = undefined,
    isOpen,
    onClose = undefined,
}) => {
    const { data, isLoading } = useGetBenefitAttributesByGroupQuery(
        {
            payerId,
            benefitGroup,
        },
        { skip: !(isOpen && payerId && benefitGroup) },
    );

    const getDialogContent = () => {
        if (isLoading) {
            return <Spinner className="padding__around--medium" />;
        }

        if (data?.length > 0) {
            return data.map((attribute) => (
                <DetailLabelValuePair
                    className="margin__bottom--medium"
                    key={attribute.attributeType}
                    label={attribute.attributeType?.replaceAll('_', ' ')}
                    value={attribute.attributeValue}
                />
            ));
        }

        return <div>This benefit group has no attributes.</div>;
    };

    return (
        <InfoDialog
            dialogTitle="Additional Benefit Information"
            width={800}
            isOpen={isOpen}
            onClose={onClose}
            dialogContent={getDialogContent()}
        />
    );
};

AdditionalBenefitInfoDialog.propTypes = {
    payerId: PropTypes.string,
    benefitGroup: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
};
